import React from 'react';

function DownArrowBlue() {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.64286 0C9.94467 0 11 1.05533 11 2.35714V8.64286C11 9.94467 9.94467 11 8.64286 11H2.35714C1.05533 11 0 9.94467 0 8.64286V2.35714C0 1.05533 1.05533 0 2.35714 0H8.64286ZM5.01591 2.74013C5.01591 2.52316 5.1918 2.34727 5.40877 2.34727C5.62573 2.34727 5.80162 2.52316 5.80162 2.74013L5.8017 4.75228L5.80177 6.76443L7.07552 5.49013C7.22894 5.33671 7.47768 5.33671 7.6311 5.49013C7.78452 5.64355 7.78452 5.89229 7.6311 6.04571L5.68656 7.99026C5.53314 8.14368 5.28439 8.14368 5.13097 7.99026L3.18643 6.04571C3.03301 5.89229 3.03301 5.64355 3.18643 5.49013C3.33985 5.33671 3.58859 5.33671 3.74201 5.49013L5.01618 6.76388L5.01604 4.752L5.01591 2.74013Z" fill="#1976D2"/>
        </svg>

    );
}

export default DownArrowBlue;